import { render, staticRenderFns } from "./BaseFilePreviewer.vue?vue&type=template&id=1bb09524&scoped=true"
import script from "./BaseFilePreviewer.vue?vue&type=script&lang=js"
export * from "./BaseFilePreviewer.vue?vue&type=script&lang=js"
import style0 from "./BaseFilePreviewer.vue?vue&type=style&index=0&id=1bb09524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb09524",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VMenu})
